import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function QrCodeIcon(props: IconProps) {
    return <Icon {...props} iconKey={"qr_code"}/>
}
